/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

// Insert any custom theme js here...

        // Get the modal
var modal = document.getElementById('myModal');

// Get the button that opens the modal
var mybtn = document.getElementById("myBtn");

// Get the <span> element that closes the modal
var span = document.getElementsByClassName("close")[0];
var spanone = document.getElementsByClassName("close")[1];
var spantwo = document.getElementsByClassName("close")[2];

// NOTE (BaseBlocks fix): #myModal/#myBtn/.close only exist on certain
// product-page sections (size-guide style popups) -- they are NOT present
// on the homepage or the /pages/collection page. Assigning `.onclick`
// straight onto `mybtn`/`span`/`spanone`/`spantwo` used to throw
// "Cannot set property 'onclick' of null/undefined" the instant this
// script ran on a page missing those elements, which is a *runtime*
// error partway through the file -- so every top-level statement AFTER
// it (including the whole BaseBlocks mobile-menu drawer block below,
// which defines window.openNavhhp/closeNavhhp) never ran at all. That is
// why tapping the hamburger on the homepage/collection page did nothing:
// the menu markup was there, but the script that opens it had already
// crashed on the missing modal elements before it ever got defined. Each
// handler below is now only attached when its element actually exists,
// so pages with the modal keep working exactly as before, and pages
// without it (home/collection) no longer block the rest of the script.

// When the user clicks on the button, open the modal
if (mybtn) {
  mybtn.onclick = function() {
    modal.style.display = "flex";
  }
}

// When the user clicks on <span> (x), close the modal
if (span) {
  span.onclick = function() {
    modal.style.display = "none";
  }
}

if (spanone) {
  spanone.onclick = function() {
    modal.style.display = "none";
  }
}

if (spantwo) {
  spantwo.onclick = function() {
    modal.style.display = "none";
  }
}

// When the user clicks anywhere outside of the modal, close it
window.onclick = function(event) {
  if (modal && event.target == modal) {
    modal.style.display = "none";
  }
};
// ^ THE ACTUAL BUG behind "the mobile menu isn't built/doesn't open": this
// semicolon was missing before. Without it, the parser doesn't end the
// statement here -- it reads the `(function () {...})();` IIFE right below
// as a CALL being made on the assignment above, i.e.
// `window.onclick = function(event){...}(function(){...})();`. That
// immediately invokes the onclick handler at script-load time (passing the
// menu-drawer IIFE itself in as `event`, which is why `event.target` was
// never a real click target), and the drawer's own function body -- which
// is where window.openNavhhp/closeNavhhp get defined -- never actually
// executes as its own call. The whole file then throws
// "TypeError: (intermediate value)(...) is not a function" partway through
// (from trying to call whatever that first invocation returned, which is
// undefined), so nothing after it, including the menu-drawer setup, ever
// ran on ANY page -- this was not specific to pages missing #myModal; it
// broke the menu everywhere, on every page, every time. Confirmed by
// reproducing the exact same "(intermediate value)(...) is not a function"
// error from this precise pattern in isolation before adding the `;`.

/* BaseBlocks mobile menu drawer: hamburger <-> close, ARIA state, scroll lock,
   Escape-to-close-and-refocus, close-on-link-click, positioned below the
   sticky header at the current scroll position. */
(function () {
  function bbMenu() {
    var menu = document.getElementById('mySidenav');
    var btn = document.getElementById('bbHambBtn');
    var header = document.querySelector('.site-header__wrapper') || document.querySelector('.site-header');
    if (!menu || !btn) return null;
    return { menu: menu, btn: btn, header: header };
  }

  function positionMenu(refs) {
    // Sets `top` (not padding) so the menu box sits *below* the header,
    // rather than covering it -- #mySidenav is a DOM child of the header,
    // and the header is what establishes the stacking context here, so a
    // fixed-position child can only stack above/below its own siblings
    // inside that same header (the logo, cart, close icon), never "under"
    // the header as a whole from outside it. An earlier version tried
    // pinning this to top:0 and relying on the header to visually cover it,
    // which instead made the menu cover the ENTIRE header (logo/cart/close
    // all disappeared) since its z-index outranks its plain siblings. Back
    // to measuring the header's real height and positioning below it --
    // combined with `transition:none` on #mySidenav (in the CSS), this now
    // applies instantly with no animated gap.
    var top = 0;
    if (refs.header) {
      // The extra -5 tucks the menu 5px up under the header's own bottom
      // edge/border, closing a small visible gap that was there before.
      top = Math.max(0, refs.header.getBoundingClientRect().bottom - 5);
    }
    refs.menu.style.top = top + 'px';
  }

  function setMenuState(refs, open) {
    if (open) positionMenu(refs);
    refs.menu.style.width = open ? '100%' : '0';
    refs.menu.style.display = open ? 'block' : 'none';
    refs.menu.setAttribute('aria-hidden', String(!open));
    refs.btn.classList.toggle('is-open', open);
    refs.btn.setAttribute('aria-expanded', String(open));
    refs.btn.setAttribute('aria-label', open ? 'Close menu' : 'Open menu');
    document.body.classList.toggle('bb-menu-open', open);
  }

  window.openNavhhp = function () {
    var refs = bbMenu();
    if (!refs) return;
    setMenuState(refs, true);
  };

  window.closeNavhhp = function () {
    var refs = bbMenu();
    if (!refs) return;
    setMenuState(refs, false);
    refs.btn.focus();
  };

  // THE ACTUAL FIX for "pressing the X doesn't close the menu": the header
  // button (#bbHambBtn) is the ONE visible control here -- its icon morphs
  // from a hamburger into an X via CSS when the menu is open (the separate
  // `.closebtn` inside the menu panel is intentionally hidden; see the CSS
  // comment on it). But the button's onclick was hardcoded to always call
  // `openNavhhp()`, every time, regardless of current state -- so clicking
  // it while already open just re-ran "open" (no visible change, since it
  // was already open) instead of closing. It looked like a close (x) button
  // but never actually closed anything. This toggles based on the menu's
  // actual current state instead, so the same button now opens when closed
  // and closes when open, matching what the morphing icon visually promises.
  window.toggleNavhhp = function () {
    var refs = bbMenu();
    if (!refs) return;
    var isOpen = refs.menu.style.display === 'block';
    setMenuState(refs, !isOpen);
  };

  document.addEventListener('DOMContentLoaded', function () {
    var refs = bbMenu();
    if (!refs) return;

    refs.menu.querySelectorAll('a').forEach(function (a) {
      a.addEventListener('click', function () { setMenuState(refs, false); });
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && refs.menu.classList.contains('open') || event.key === 'Escape' && refs.menu.style.display === 'block') {
        setMenuState(refs, false);
        refs.btn.focus();
      }
    });

    window.addEventListener('resize', function () {
      if (refs.menu.style.display === 'block') positionMenu(refs);
    });
  });
})();